export default function Week({ className }: { className?: string }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='98'
      height='25'
      viewBox='0 0 98 25'
      fill='none'
      className={className}
    >
      <g clipPath='url(#clip0_455_7633)'>
        <path
          d='M41.9778 0.455078L43.5851 13.671L45.9563 0.504462L50.1728 0.474696L52.155 13.671L54.1371 0.474696L58.7596 0.457108L54.3157 24.0444L49.8326 24.0247L47.8701 11.1639L45.8879 24.0031H40.9245L36.9785 0.455078H41.9778Z'
          fill='#D4D1CE'
        />
        <path
          d='M88.7527 0.455078V9.02488L91.9668 0.455078H97.3232L93.0857 10.6329L97.3219 24.02L92.3097 23.8583L89.8209 15.3846C89.1336 16.1247 88.7534 16.8681 88.7534 17.0589V24.022H84.1113V0.455078H88.7534H88.7527Z'
          fill='#D4D1CE'
        />
        <path
          d='M70.1874 0.455078V4.38279H64.8315V10.2994L69.4797 10.3021L69.475 14.0262L64.8315 14.0242V20.095H70.1874V24.0227H60.1895V0.455078H70.1874Z'
          fill='#D4D1CE'
        />
        <path
          d='M81.9966 0.455078V4.38279H76.6401V10.2994L81.2883 10.3021L81.2843 14.0262L76.6401 14.0242V20.095H81.9966V24.0227H71.998V0.455078H81.9966Z'
          fill='#D4D1CE'
        />
        <path
          d='M35.1946 0.455078V2.59753H28.7672V11.1673H34.8374V13.3105H28.7672V21.8803H35.5518V24.0227H26.2676V0.455078H35.1946Z'
          fill='#D4D1CE'
        />
        <path
          d='M4.48436 2.59753V24.0227H6.984V2.59753L10.9138 2.59956L10.9117 0.455078H0.556641V2.59753H4.48436Z'
          fill='#D4D1CE'
        />
        <path
          d='M21.9758 0.455078V11.1673H15.1913V0.455078H13.0488V24.0227H15.1913V13.3105H21.9758V24.0227H24.1183V0.455078H21.9758Z'
          fill='#D4D1CE'
        />
      </g>
      <defs>
        <clipPath id='clip0_455_7633'>
          <rect
            width='96.7703'
            height='23.5893'
            fill='white'
            transform='translate(0.556641 0.455078)'
          />
        </clipPath>
      </defs>
    </svg>
  );
}
